import React, { useState, useEffect } from 'react'
import { Container, Header } from "semantic-ui-react";
import styled from "styled-components";
import { Storage } from "@aws-amplify/storage"
import {Link} from "react-router-dom"

function Addfunction() {

  const [filename, setFilename] = useState("")

    const cancel = () => {

    }

    const namehandler = (e) => {
      console.log(e.target.value)
      setFilename(e.target.value)
    }

    const makeCode = async () => {

      const code = "print('nice to meet you!')"

      const s3upload = await Storage.put("code/" + filename + ".py", code, {
        level: 'private',
        contentType: 'text/plain'
      });
  
      console.log("업로드된 파일명",s3upload.key)

      setTimeout(function() {
        if ( window.location.hostname === 'localhost' ) {
            window.location.href=`http://localhost:3000/editor/${filename}`;
        } else if ( window.location.hostname === 'quickpoly' ) {
            window.location.href=`https://quickpoly.com/editor/${filename}`;
        }
    }, 500);
  
    }

  return (
    <>
        <nav className="bg-white border-gray-900 px-2 sm:px-4 py-2.5 dark:bg-gray-900">
        <div className="flex flex-wrap items-center justify-between mx-auto">
          <a href="https://flowbite.com/" className="flex items-center">
              <span class="self-center text-xl font-semibold whitespace-nowrap dark:text-white">QuickPloy</span>
          </a>        
          <div class="flex md:order-2">
            {/* <Link to="/manage">
            <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">내 페이지</button>
            <button data-collapse-toggle="navbar-cta" type="button" class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-cta" aria-expanded="false">
              <span class="sr-only">Open main menu</span>
              <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
            </button>
            </Link> */}
            <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" style={{marginLeft:"20px"}} onClick={cancel}>로그오프</button>
              <button data-collapse-toggle="navbar-cta" type="button" class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-cta" aria-expanded="false">
                <span class="sr-only">Open main menu</span>
                <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
            </button>
          </div>
        </div>
      </nav>

      <div style={{marginTop:"100px", textAlign:"center", fontSize:"20px", fontWeight:"900"}}>
        새로 만들기
        <div style={{marginTop:"20px"}}>
          <Link to="/manage">
          <button class="bg-transparent text-sm hover:bg-black text-black font-semibold hover:text-white py-1 px-2 border border-black hover:border-transparent rounded">
                  + 돌아가기
                  {/* <svg aria-hidden="true" class="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> */}
              </button>
          </Link>
        </div>
      </div>

      <div style={{marginTop:"50px"}}></div>


      <div style={{width:"90%", margin:"0px auto", gap:"20px", display:"flex", flexDirection:"row", flexWrap:"wrap", justifyContent:"center"}}>

      <div class="p-6 bg-white border border-gray-900 rounded-lg shadow dark:bg-white" style={{width:"300px"}}>
                    <div class="flex flex-wrap text-center mb-1">
                      <div class="mr-2 mb-2 rounded-full px-3 py-1 text-xs bg-green-200 text-green-800">Python</div>
                    </div>
                    <Amountgroup>
                      <InputAmount type="text" value="" name="ticketNum" required/>
                      <LabelAmount>이름 (4글자 이상)</LabelAmount>
                    </Amountgroup>

                    <Buttonb>
                      만들기
                    </Buttonb>


                  </div>     
        </div>    
    </>

  );
}

const Buttonb = styled.button`
    height: 50px;
    color: white;
    background-color: black;
    border-radius: 8px;
    font-size: 14px;
    width: 100%;
    border: none;
    font-weight: 700;

    &:hover {
      background-color: gray;
    }
`

const TodoTemplateBlock = styled.div`
  position: relative; /* 추후 박스 하단에 추가 버튼을 위치시키기 위한 설정 */
  background: white;
  border-radius: 16px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
  margin: 0 auto; /* 페이지 중앙에 나타나도록 설정 */
  display: flex;
  flex-direction: column;
`;

const Contentcontainer = styled.div`
  width: 100%;
  text-align: center;
`;

const Input = styled.input.attrs((props) => ({
    size: props.size || "2em",
  }))`
    border: 2px solid blue;
    height: 50px;
    width: 200px;
    text-align: right;
    font-size: 15pt;
  `;
  


const Cardbutton = styled.button.attrs((props) => ({
    type: "submit",
  }))`
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    border: none;
    outline: 0;
    padding: 12px;
    color: white;
    background-color: gray;
    text-align: center;
    cursor: pointer;
    width: 100%;
    font-size: 18px;
    margin-bottom: 1.5em;
  `;


const Amountgroup = styled.div`
  position:relative; 
  margin-top:20px; 
  margin-bottom:45px; 
  width: 100%;
`

const InputAmount = styled.input`
  font-size:18px;
  padding:10px 10px 10px 5px;
  display:block;
  width:100%;
  border:none;
  border-bottom:1px solid #757575;

  &:focus {
    outline:none;
  }

  &:focus ~ label {
    top:-20px;
    font-size:14px;
    color:#5264AE;  
  }

  &:valid ~ label {
    top:-20px;
    font-size:14px;
    color:#5264AE;
    /* background-color: yellow; */
  }
`

const LabelAmount = styled.label`
  color:#999; 
  font-size:18px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all; 
  -moz-transition:0.2s ease all; 
  -webkit-transition:0.2s ease all;
/* 
  &:focus {
    top:-20px;
    font-size:14px;
    color:#5264AE;  
  }

  &:valid {
    top:-20px;
    font-size:14px;
    color:#5264AE;
  } */
  
`


export default Addfunction;


